import React, { useEffect } from 'react'
import { Link } from "react-router-dom";

import NavBar from '../Common/Navbar'
import OurTeam from '../Home/OurTeam'
import team1 from '../../assets/Images/team-slider1.png'
import team2 from '../../assets/Images/team-slider2.png'
import team3 from '../../assets/Images/team-slider3.png'
import team4 from '../../assets/Images/team-slider4.png'
import team5 from '../../assets/Images/team5.png'
import team6 from '../../assets/Images/team6.png'
import team7 from '../../assets/Images/team7.png'
import team8 from '../../assets/Images/team8.png'

import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import Testimonial from '../Home/Testimonial'
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '../Home/TopButton';
import Gallery from '../Home/Gallery';


function Team() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Meet Our Team</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/team">Team</Link>
                    </div>
                </div>
            </div>
            <div className="team">
                <div className="container">
                    <div className="team-slider d-flex align-items-center mt-5">
                        <div className="team-img d-flex align-items-center">
                            <img src={team1} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jane Doe</h3>
                                    <h4>Designer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team2} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Kaitti Pairi</h3>
                                    <h4>Seo Expert</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team3} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jonny coll</h3>
                                    <h4>Developer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team4} alt="team1.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Anni Doe</h3>
                                    <h4>UI/UX</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="team-slider d-flex align-items-center"> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1700" */}
                        <div className="team-img d-flex align-items-center">
                            <img src={team5} alt="team5.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jane Doe</h3>
                                    <h4>Designer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team6} alt="team6.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Kaitti Pairi</h3>
                                    <h4>Seo Expert</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team7} alt="team7.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Jonny coll</h3>
                                    <h4>Developer</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-img d-flex align-items-center">
                            <img src={team8} alt="team8.img" />
                            <div className="overlay">
                                <div className="overlay-text text-center">
                                    <h3>Anni Doe</h3>
                                    <h4>UI/UX</h4>
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <a href="#"><FaFacebookF /></a>
                                        <a href="#"><FaWhatsapp /></a>
                                        <a href="#"><FaInstagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Testimonial />
            <FooterMenu />
            <Copyright />
            <TopButton />
        </>
    )
}

export default Team
